export function parseDate(d) {
    d = new Date(d);
    return new Date(d.getTime() - d.getTimezoneOffset() * 60 * 1000);
}

export const getLanguageAttr = (c, ls) => {
    const lang = c.hasAttribute('data-language') ? c.getAttribute('data-language') : navigator.language;
    return ls.indexOf(lang) >= 0 ? lang : ls[0]
}


